import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import ModularSofasPage from './ModularSofasPage';
const ModularSofasPageWrapper = t0 => {
  const $ = _c(2);
  const {
    isAdmin: t1
  } = t0;
  const isAdmin = t1 === undefined ? false : t1;
  if (isAdmin) {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="ModularSofasStatic__container"><div className="flex min-h-[30vh] items-center justify-center"><p className="text-lg font-medium">Modular sofas placeholder</p></div></div>;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    return t2;
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ModularSofasPage />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};
ModularSofasPageWrapper.propTypes = {
  isAdmin: PropTypes.bool
};
export default ModularSofasPageWrapper;